import React from 'react';
import {useLocation} from 'react-router-dom';
import {useAuth} from '../context/AuthContext';
import {useOutletContext} from '../context/OutletContext';
import {useBrandIdentity} from './BrandRuntimeGate';
import {verifiedMode,modeEpoch} from '../lib/workspaceMode';
import OwnerPaymentNotices from './OwnerPaymentNotices';
export default function OwnerPaymentAlerts(){
 const {user}=useAuth(),{activeOutletId}=useOutletContext(),{brand_key}=useBrandIdentity(),{pathname}=useLocation();
 const env=verifiedMode();
 const enabled=brand_key==='rolls_and_brew'&&['owner','admin','user'].includes(user?.role)&&!!activeOutletId&&!!env&&!/^\/(order(?:\/|$)|track|pay|self-order|rider|public|login|register|feedback)/.test(pathname);
 return <OwnerPaymentNotices key={`${activeOutletId}:${env}:${modeEpoch()}`} enabled={enabled} env={env} outletId={activeOutletId}/>;
}
